import React from 'react';
import styles from './Logo.css';

class Logo extends React.PureComponent {
  render() {
    return (
      <img
        src={this.props.src}
        className={styles.thumbnail}
        style={this.props.style}
      />
    );
  }
}

export default Logo;
